module.exports = __webpack_public_path__ + "static/media/forward.1a8e6ac3.svg";